import { isRetailer } from 'core/api/user';
import { selectHasCatalogFilterStatusFeature } from 'modules/feature-flag/selectors';

export const targetProductStatusFilter = {
  key: 'targetProductStatus',
  query: 'productstatus',
  isAvailable: ({ user } = {}) =>
    isRetailer(user) && selectHasCatalogFilterStatusFeature(user),
};
